function home() {
  $("html,body").animate({scrollTop: 0}, 500);
}

function product() {
  $("html,body").animate({scrollTop: $("#Product").offset().top}, 500);
}

function og() {
  $("html,body").animate({scrollTop: $("#OG").offset().top}, 500);
}

function partner() {
  $("html,body").animate({scrollTop: $("#Partner").offset().top}, 500);
}

function roadmap() {
  $("html,body").animate({scrollTop: $("#Roadmap").offset().top}, 500);
}
